var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"autocomplete":"off","label":_vm.label,"value":_vm.textVal,"background-color":_vm.computedError||_vm.error?'#ff9898':'#ffffff',"disabled":_vm.disabled},on:{"input":_vm.setValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }